import React from "react"
import TableHeaderRow from "../../ui/TableHeaderRow"
import TableHeader from "../../ui/TableHeader"
import TextFilter from "../filters/TextFilter"
import SortHeader from "../sorting/SortHeader"
import DateTimeFilter from "../filters/DateTimeFilter"
import { Link, useNavigate } from "react-router-dom"
import Table, { Row, Cell } from "../../ui/Table"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import { selectAdvancedMode } from "../settings/slice"
import IDCopy from "../../ui/IDCopy"
import Timestamp from "../../ui/Timestamp"
import DropDownFilter from "../filters/DropDownFilter"
import { selectSubmissionStatutes } from "./slice"
import styled from "styled-components"

const SubmissionStatus = styled.span`
  color: ${(props) => props.color};
`

const SubmissionsTable = ({
  submissions = [],
  filter,
  setFilter,
  stickyHeader = true,
}) => {
  // User setting to show more details such as id's
  const advancedModeState = useSelector(selectAdvancedMode)
  const submissionStatuses = useSelector(selectSubmissionStatutes) // The various types of RSO
  // if filters apply to advancedMode columns we have to show them
  const advancedModeOverride = filter && filter.id_cnts ? true : false
  const advancedMode = advancedModeOverride
    ? advancedModeOverride
    : advancedModeState
  const navigate = useNavigate()
  const navigateTo = (id) => () => navigate(`/data-submissions/${id}`)

  return (
    <Table>
      <TableHeaderRow sticky={stickyHeader}>
        <TableHeader
          filterControl={
            filter && (
              <DateTimeFilter
                filter={filter}
                setFilter={setFilter}
                active={filter.from || filter.to ? true : false}
              />
            )
          }
          sortControl={
            filter && (
              <SortHeader
                setFilter={setFilter}
                filter={filter}
                sortBy={"created_at"}
              />
            )
          }
        >
          Created
        </TableHeader>
        {advancedMode && (
          <TableHeader
            filterControl={
              filter && (
                <TextFilter
                  filterByName="id_cnts"
                  filter={filter}
                  setFilter={setFilter}
                  active={filter.id}
                />
              )
            }
          >
            ID
          </TableHeader>
        )}
        <TableHeader
          filterControl={
            filter && (
              <TextFilter
                filterByName="label_cnts"
                filter={filter}
                setFilter={setFilter}
                active={filter.label_cnts}
              />
            )
          }
          sortControl={
            filter && (
              <SortHeader
                setFilter={setFilter}
                filter={filter}
                sortBy={"label"}
              />
            )
          }
        >
          Label
        </TableHeader>
        <TableHeader>Destination</TableHeader>
        <TableHeader
          filterControl={
            (filter && (
              <DropDownFilter
                values={Object.values(submissionStatuses).map((status) => {
                  return { name: status.name, value: status.name }
                })}
                filterByName="status"
                filter={filter}
                setFilter={setFilter}
                active={filter.status ? true : false}
              />
            )) ||
            undefined
          }
          sortControl={
            (filter && (
              <SortHeader
                setFilter={setFilter}
                filter={filter}
                sortBy={"status"}
              />
            )) ||
            undefined
          }
        >
          Status
        </TableHeader>
        <TableHeader>No. samples</TableHeader>
        {/*Actions*/}
        <TableHeader />
      </TableHeaderRow>
      {submissions && (
        <tbody>
          {submissions.map((submission) => (
            <Row key={submission.id} zebra>
              <Cell onClick={navigateTo(submission.id)}>
                <Timestamp utc={advancedMode} columnMode={true}>
                  {submission.created_at}
                </Timestamp>
              </Cell>
              {advancedMode && (
                <Cell onClick={navigateTo(submission.id)}>
                  <IDCopy truncateTo={20} id={submission.id} showCopy={true} />
                </Cell>
              )}
              <Cell>{submission.label}</Cell>
              <Cell>{submission.destination}</Cell>
              <Cell>
                <SubmissionStatus
                  color={
                    findStatusByKey(submission.status, submissionStatuses)
                      ?.colorCode
                  }
                >
                  {submission.status}
                </SubmissionStatus>
              </Cell>
              <Cell>
                {submission?.samples?.length > 0
                  ? submission.samples.length
                  : 0}
              </Cell>
              <Cell>
                <Link to={`/data-submissions/${submission.id}`}>Detail</Link>
              </Cell>
            </Row>
          ))}
        </tbody>
      )}
    </Table>
  )
}

const findStatusByKey = (requestedKey, statuses = {}) => {
  // eslint-disable-next-line
  return Object.values(statuses).find((status) => {
    return status.name == requestedKey?.toLowerCase()
  })
}

SubmissionsTable.propTypes = {
  submissions: PropTypes.array, // the submissions to render
  filter: PropTypes.object, // If provided will be used to power the filters if not filters will not be shown
  setFilter: PropTypes.func, // If provided will be used to power the filters if not filters will not be shown
  stickyHeader: PropTypes.bool, // If true, table header is sticky
}

export default SubmissionsTable
